import React from 'react';
import {
  Modal,
  Button,
  Card,
  Row,
  Col,
  Divider,
  Tabs,
  Table,
  message,
  Typography,
  Layout,
  Menu,
  Icon,
  Input,
  Statistic,
  Pagination,
  InputNumber,
  List,
  Tooltip,
  Form,
} from 'antd';
import { useTableLocale, useDebounce } from '../../../components/use';
import { InputNum } from '../../../components/biz';
import { network, generators, asserts, maths } from '../../../utils';
import api from '../../../config/api';
import paginationCfg from '../../../config/pagination.cfg';
import PreviewImgModal from '../PreviewImgModal';
import AddressAdd from './AddressAdd';
import getUdc from '../../../service/udc';
import { concat } from 'ramda';
import './index.less';

const { TabPane } = Tabs;
const { Text } = Typography;
const { Sider, Content } = Layout;
const { generatorArray, generatorObject } = generators;
const { isExist } = asserts;
const down = `${process.env.TARGET}static/imgs/cartOrder/icon_down.svg`;
const up = `${process.env.TARGET}static/imgs/cartOrder/icon_up.svg`;
const tabList = [
  {
    key: '1',
    name: '优惠券',
  },
  {
    key: '2',
    name: '礼品',
  },
];

export default Form.create()(({ form, onCancel, onExchange, points }) => {
  const formRef = React.useRef();
  const [exchangeVisible, setExchangeVisible] = React.useState();
  const [list, setList] = React.useState([]);
  const [value, setValue] = React.useState({});
  const [showOption, setShowOption] = React.useState(false);
  const [activeKey, setActiveKey] = React.useState(tabList[0].key);
  const [dataSource, setDataSource] = React.useState([]);
  const [tbLoading, setTbLoading] = React.useState(false);
  const [pagination, setPagination] = React.useState({ ...paginationCfg, pageSize: 12 });
  const [locale, fetchingStatus] = useTableLocale();
  const [usedPoints, setUsedPoints] = React.useState(0); // 消耗积分
  const [remainPoints, setRemainPoints] = React.useState(0); // 剩余积分
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [previewVisible, setPreviewVisible] = React.useState(false);
  const [currentImg, setCurrentImg] = React.useState(null);
  const [addrVisible, setAddrVisible] = React.useState(false);
  const [formData, setFormData] = React.useState({});
  const [menuList, setMenuList] = React.useState([]);
  const [sortingType, setSortingType] = React.useState('DEFAULT');
  const [itemCateType, setItemCateType] = React.useState('ALL');
  // const [changePointsFrom, setChangePointsFrom] = React.useState(null);
  // const [changePointsTo, setChangePointsTo] = React.useState(null);
  const [selectedIds, setSelectedIds] = React.useState([]);
  const [changeablePoints, setChangeablePoints] = React.useState(0);
  const [isExchanged, setIsExchanged] = React.useState(false);
  const { getFieldDecorator, getFieldsValue } = form;

  React.useEffect(() => {
    setExchangeVisible(true);
    setChangeablePoints(points);
    fetchCates();
    fetch();
    fetchTableData({
      current: 1,
      pageSize: pagination.pageSize,
      activeKey,
    });
  }, []);

  React.useEffect(() => {
    fetchingStatus(tbLoading);
  }, [tbLoading]);

  React.useEffect(() => {
    let points = 0;
    dataSource.forEach((item) => {
      if (asserts.isExist(item.qty)) {
        let needPoints = item.changePoints;
        points = maths.add(points, maths.mul(needPoints || 0, item.qty));
      }
    });
    setUsedPoints(points);
    setRemainPoints(maths.sub(changeablePoints || 0, points));
  }, [dataSource, changeablePoints]);

  const fetchCates = async () => {
    const response = await getUdc('pointItemCateType');
    if (response.success) {
      const dataSource = generatorArray(response.data);
      const allItems = [{ code: 'ALL', name: '全部商品' }];
      setMenuList(concat(allItems, dataSource));
    }
  };

  const fetch = async () => {
    const response = await network.get(api.activeArea.luckyDraw.addrList);
    if (response.success) {
      const result = generators.generatorObject(response.data);
      if (!result.success) {
        message.error(result.message);
        return;
      }
      let addrList = generators.generatorArray(result.data);
      setList(addrList);
      setValue(addrList.length ? addrList[0] : {});
    }
  };

  const fetchTableData = async (params) => {
    const { current, pageSize, activeKey } = params;
    let url = null;
    // if (activeKey === '1') {
    //   url = `${api.profile.queryCouponsAndItems}?itemType=A`;
    // }
    // if (activeKey === '2') {
    //   url = `${api.profile.queryCouponsAndItems}?itemType=B`;
    // }
    let pointRange = getFieldsValue();
    let itemCateType1 = params.itemCateType || itemCateType;
    setTbLoading(true);
    let queryParams = {
      ...params,
      ...pointRange,
      itemCateType: itemCateType1 === 'ALL' ? '' : itemCateType1,
      sortingType: params.sortingType || sortingType,
      pageIndex: current,
    };
    const res = await network({
      url: api.profile.queryCouponsAndItems,
      method: 'post',
      data: {
        ...queryParams,
      },
    });
    if (res.success) {
      const result = generatorObject(res.data);
      const { rows = [], total = 0 } = result;
      let newData = generatorArray(rows).map((item, index) => {
        let qty = maths.sub(item.personalCount || 0, item.purchaseQty || 0); // 可免换数量 (不能小于0) =限兑数量-已兑换数量
        let syNum = item.itemType === 'A' ? item.unuseNum || 0 : item.remainCount || 0; // 剩余数量
        let usingQty = qty !== 0 ? (qty < syNum ? qty : syNum) : 0; // 可兑换数量小于剩余数量就展示可兑换数量  可兑换数量大于剩余数量就展示剩余数量
        return {
          ...item,
          usingQty,
        };
      });
      // let usingQtyList = newData.filter((item) => item.usingQty); // 未兑换完
      // let userQtyList = newData.filter((item) => !item.usingQty); // 兑换完
      // let newList = concat(usingQtyList, userQtyList).map((item, index) => {
      //   return {
      //     ...item,
      //     rowKey: index,
      //     qty: item.changeable ? item.qty : null,
      //   };
      // });
      let newList = newData.map((item, index) => {
        return {
          ...item,
          rowKey: index,
          qty: item.changeable ? item.qty : null,
        };
      });
      // console.log(newList, 'newList');
      setDataSource(newList);
      setPagination({
        ...pagination,
        ...params.pagination,
        current,
        pageSize,
        total,
      });
      setTbLoading(false);
    } else {
      setTbLoading(false);
      message.error(res.message);
    }
  };

  const handleShowOption = () => setShowOption(!showOption);

  const options = React.useMemo(() => {
    const filterData = list.filter(({ an82 }) => an82 !== value.an82);
    return filterData;
  }, [list, value]);

  const handleSelectAddress = (item) => {
    // if (`${item.fstatus}` !== '2') return;
    // getServiceAmtByAddress(item);
    setValue(item);
    setShowOption(false);
  };

  const handleChangeActive = (e) => {
    setActiveKey(e);
    setDataSource([]);
    fetchTableData({ current: 1, pageSize: pagination.pageSize, activeKey: e });
  };

  const handleQtyhange = (value, index) => {
    setDataSource((preList) =>
      preList.map((pre) => {
        if (pre.rowKey === index) {
          return {
            ...pre,
            qty: value,
          };
        }
        return pre;
      }),
    );
  };

  const renderTableColumns = (key) => {
    let columns = [];
    if (key === '1') {
      columns.push(
        {
          title: '名称',
          dataIndex: 'cpnName',
          align: 'center',
          name: '名称',
        },
        {
          title: '总金额',
          dataIndex: 'cpnAmt',
          align: 'center',
          name: '总金额',
          render: (value, record, index) => {
            if (record.ctype == 1) {
              return value;
            }
            if (record.ctype == 2) {
              return record.cpnLimitAmt;
            }
            return null;
          },
        },
        {
          title: '有效期',
          dataIndex: 'date',
          align: 'center',
          name: '有效期',
          width: '12%',
          render: (value, record, index) => {
            return (
              <span>
                {record.validStart}~{record.validEnd}
              </span>
            );
          },
        },
        {
          title: '规则',
          dataIndex: 'cpnRule',
          align: 'center',
          name: '规则',
        },
        {
          title: '使用范围',
          dataIndex: 'cpnDesc',
          align: 'center',
          name: '使用范围',
          width: '20%',
        },
        {
          title: '兑换时间',
          dataIndex: 'cycleDate',
          align: 'center',
          name: '兑换时间',
          width: '12%',
          render: (value, record, index) => {
            const { cycleFrom, cycleTo } = record;
            let year = new Date().getFullYear();
            let month = new Date().getMonth() + 1;
            if (month.length === 1) {
              month = '0' + month;
            }
            return `${year}-${month}-${cycleFrom} 00:00 ~ ${year}-${month}-${cycleTo} 23:59`;
          },
        },
        {
          title: '所需积分',
          dataIndex: 'changePoints',
          align: 'center',
          name: '所需积分',
        },
        // {
        //   title: '限兑数量',
        //   dataIndex: 'personalCount',
        //   align: 'center',
        //   name: '限兑数量',
        // },
        // {
        //   title: '剩余数量',
        //   dataIndex: 'unuseNum',
        //   align: 'center',
        //   name: '剩余数量',
        // },
        {
          title: '可兑换数量',
          dataIndex: 'usingQty',
          align: 'center',
          name: '可兑换数量',
          // render: (value, record, index) => {
          //   let qty = maths.sub(record.personalCount || 0, record.purchaseQty || 0);
          //   return <span>{qty !== 0 ? (qty < record.unuseNum ? qty : record.unuseNum) : 0}</span>;
          // },
        },
      );
    }
    if (key === '2') {
      columns.push(
        {
          title: '商品名称',
          dataIndex: 'itemName',
          align: 'center',
          name: '商品名称',
        },
        {
          title: '商品图片',
          dataIndex: 'itemPicAddr',
          align: 'center',
          name: '商品图片',
          render: (value, record, index) => {
            return value ? (
              <img
                src={`${process.env.ASSETS}/${value}`}
                alt=""
                style={{ width: 60, height: 60 }}
                onClick={() => handlePreview(value)}
              />
            ) : null;
          },
        },
        {
          title: '兑换时间',
          dataIndex: 'cycleDate',
          align: 'center',
          name: '兑换时间',
          width: '15%',
          render: (value, record, index) => {
            const { cycleFrom, cycleTo } = record;
            if (asserts.isExist(cycleFrom) && asserts.isExist(cycleTo)) {
              let year = new Date().getFullYear();
              let month = new Date().getMonth() + 1;
              if (month.length === 1) {
                month = '0' + month;
              }
              return `${year}-${month}-${cycleFrom} 00:00 ~ ${year}-${month}-${cycleTo} 23:59`;
            }
            return null;
          },
        },
        // {
        //   title: '剩余数量',
        //   dataIndex: 'remainCount',
        //   align: 'center',
        //   name: '剩余数量',
        // },
        // {
        //   title: '限兑数量',
        //   dataIndex: 'personalCount',
        //   align: 'center',
        //   name: '限兑数量',
        // },
        {
          title: '单位',
          dataIndex: 'unit',
          align: 'center',
          name: '单位',
        },
        {
          title: '所需积分',
          dataIndex: 'changePoints',
          align: 'center',
          name: '所需积分',
        },
        {
          title: '可兑换数量',
          dataIndex: 'usingQty',
          align: 'center',
          name: '可兑换数量',
          // render: (value, record, index) => {
          //   let qty = maths.sub(record.personalCount || 0, record.purchaseQty || 0);
          //   return (
          //     <span>{qty !== 0 ? (qty < record.remainCount ? qty : record.remainCount) : 0}</span>
          //   );
          // },
        },
      );
    }
    columns.push({
      title: '兑换数量',
      dataIndex: 'qty',
      align: 'center',
      name: '兑换数量',
      render: (value, record, index) => {
        if (record.usingQty === 0) return '已兑完';
        return (
          <InputNum
            placeholder="0"
            value={value}
            style={{ width: 60, padding: 4 }}
            maxLength={8}
            onChange={(val) => handleQtyhange(val, index)}
            disabled={!record.changeable}
          />
        );
      },
    });
    return columns;
  };

  // 预览图片
  const handlePreview = (img) => {
    setCurrentImg(img);
    setPreviewVisible(true);
  };

  const handleChangePreview = () => {
    setCurrentImg(null);
    setPreviewVisible(false);
  };

  const handleChange = (current, pageSize) => {
    if (pageSize !== pagination.pageSize) {
      current = 1;
    }
    setPagination({
      ...pagination,
      current,
      pageSize,
    });
    fetchTableData({ current, pageSize, activeKey });
  };

  const handleGoBack = () => {
    setExchangeVisible(false);
    onCancel && onCancel(isExchanged);
  };

  const handleExchange = async () => {
    if (!asserts.isExist(value)) {
      message.warn('请选择收货地址');
      return;
    }
    // let newData = dataSource.filter((item) => asserts.isExist(item.qty));
    let newData = dataSource.filter((item) => selectedIds.includes(item.id));
    if (!newData.length) {
      message.warn('请输入要兑换商品行的兑换数量');
      return;
    }
    let errMsgs = [];
    newData.forEach((item, index) => {
      if (item.personalCount < item.qty) {
        errMsgs.push(`第${index + 1}行的兑换数量不能大于限兑数量`);
      }
    });
    if (errMsgs.length) {
      message.warn(errMsgs.join(','));
      return;
    }
    setConfirmLoading(true);
    let params = {
      receiveName: value.shrxm,
      receiveMobile: value.sj,
      receiveAddr: value.xxdz,
      dvan: value.an82,
      orderType: activeKey === '1' ? 'A' : 'B',
      totalPoints: usedPoints,
      detailList: newData.map((item) => {
        return {
          actId: activeKey === '1' ? -1 : 0,
          itemId: item.id,
          itemName: activeKey === '1' ? item.cpnName : item.itemName,
          qty: item.qty,
          points: item.changePoints,
        };
      }),
    };
    // console.log(params, 'params');
    const res = await network({
      url: api.profile.placePointsOrder,
      method: 'post',
      data: params,
    });

    setConfirmLoading(false);
    if (res.success) {
      let result = generatorObject(res.data);
      if (!result.success) {
        message.error(result.message);
        return;
      }

      message.success('兑换成功');
      setExchangeVisible(false);
      onExchange && onExchange();
    } else {
      message.error(res.message);
    }
  };

  const handleShowModal = () => {
    setAddrVisible(true);
  };

  const handleCancel = () => {
    setFormData({});
    setAddrVisible(false);
  };

  const handleOk = () => {
    const { validateFields, getFieldValue, setFields } = formRef.current;
    validateFields((err, val) => {
      if (err) {
        return;
      }
      const { shrxm, xxdz, phoneNumber } = val;
      const addParams = {
        shrxm,
        xxdz,
        sj: phoneNumber,
        an82: null,
      };
      setAddrVisible(false);
      setFormData({});
      setValue(addParams);
      let newData = concat(list, [addParams]);
      setList(newData);
    });
  };

  // 切换菜单
  const handleSwitchMenu = (e) => {
    // setDefaultSelectedKeys([e.key]);
    setItemCateType(e.key);
    fetchTableData({
      current: 1,
      pageSize: pagination.pageSize,
      itemCateType: e.key,
    });
  };

  const handleFilter = (value) => {
    let newSortingType = null;
    if (value === 'DEFAULT') {
      newSortingType = 'DEFAULT';
    } else if (value === 'NEW') {
      if (sortingType === 'NEW_UP') {
        newSortingType = 'NEW_DOWN';
      }
      if (
        sortingType === 'NEW_DOWN' ||
        sortingType === 'DEFAULT' ||
        sortingType === 'POINT_UP' ||
        sortingType === 'POINT_DOWN'
      ) {
        newSortingType = 'NEW_UP';
      }
    } else if (value === 'POINT') {
      if (sortingType === 'POINT_UP') {
        newSortingType = 'POINT_DOWN';
      }
      if (
        sortingType === 'POINT_DOWN' ||
        sortingType === 'DEFAULT' ||
        sortingType === 'NEW_DOWN' ||
        sortingType === 'NEW_UP'
      ) {
        newSortingType = 'POINT_UP';
      }
    }
    setSortingType(newSortingType);
    fetchTableData({
      current: 1,
      pageSize: pagination.pageSize,
      sortingType: newSortingType,
    });
  };

  const handleSearch = (e) => {
    fetchTableData({
      current: 1,
      pageSize: pagination.pageSize,
      itemName: e,
    });
  };

  const handleFilterPoint = (e, field) => {
    // let value = e.target.value;
    // console.log(value, 'value');
    // let params = {
    //   current: 1,
    //   pageSize: pagination.pageSize,
    // };
    // params[field] = value;
    // if (field === 'changePointsFrom') {
    //   setChangePointsFrom(value);
    //   params['changePointsTo'] = changePointsTo;
    // }
    // if (field === 'changePointsTo') {
    //   setChangePointsTo(value);
    //   params['changePointsFrom'] = changePointsFrom;
    // }
    fetchTableData({
      current: 1,
      pageSize: pagination.pageSize,
    });
  };

  const handleChooseItem = (item) => {
    let newSelectedIds = [];
    if (selectedIds.includes(item.id)) {
      newSelectedIds = selectedIds.filter((itm) => itm !== item.id);
    } else {
      newSelectedIds = Array.from(new Set(concat([item.id], selectedIds)));
    }
    setSelectedIds(newSelectedIds);
  };

  // 兑换
  const handleExChangeItem = async (item) => {
    setTbLoading(true);
    if (!asserts.isExist(value)) {
      message.warn('请选择收货地址');
      setTbLoading(false);
      return;
    }

    if (item.personalCount < item.qty) {
      message.warn(`兑换数量不能大于限兑数量${item.personalCount}`);
      setTbLoading(false);
      return;
    }

    let params = {
      receiveName: value.shrxm,
      receiveMobile: value.sj,
      receiveAddr: value.xxdz,
      dvan: value.an82,
      orderType: item.itemType,
      totalPoints: usedPoints,
      detailList: [
        {
          actId: item.itemType === 'A' ? -1 : 0,
          itemId: item.id,
          itemName: item.itemName,
          qty: item.qty,
          points: item.changePoints,
        },
      ],
    };
    // console.log(params, 'params');
    const res = await network({
      url: api.profile.placePointsOrder,
      method: 'post',
      data: params,
    });

    setTbLoading(false);
    if (res.success) {
      let result = generatorObject(res.data);
      if (!result.success) {
        message.error(result.message);
        return;
      }
      let newChangeablePoints = maths.sub(changeablePoints || 0, item.changePoints || 0);
      setChangeablePoints(newChangeablePoints);
      setIsExchanged(true);
      message.success('兑换成功');
      // setExchangeVisible(false);
      // onExchange && onExchange();
    } else {
      message.error(res.message);
    }
  };

  const renderItemTip = (item) => {
    return (
      <div style={{ maxWidth: 320 }}>
        {item.itemType === 'A' ? (
          <>
            <p>{item.cpnDesc ? `使用范围：${item.cpnDesc}` : ''}</p>
            <p>{item.cpnDesc ? `规则：${item.cpnRule}` : ''}</p>
            <p>{item.cpnDesc ? `有效期：${item.validStart}~${item.validEnd}` : ''}</p>
          </>
        ) : (
          <>
            <p>{item.itemDescribe ? `详情：${item.itemDescribe}` : ''}</p>
          </>
        )}
      </div>
    );
  };

  return (
    <>
      <Modal
        title="兑换中心"
        visible={exchangeVisible}
        width={1300}
        centered
        footer={[
          <Button type="dafault" onClick={handleGoBack}>
            返回
          </Button>,
          // <Button type="danger" onClick={handleExchange} loading={confirmLoading}>
          //   兑换
          // </Button>,
        ]}
        className="exchange-modal"
        onCancel={() => handleGoBack()}
      >
        <div className="wrapper-content">
          <Card
            title={
              <div>
                <span>收货地址</span>
                {/* <span className="text-error" style={{ fontSize: 13, marginLeft: 8 }}>
                *请注意检查送货地址是否正确
              </span> */}
              </div>
            }
            bordered={true}
            className="order-info-card"
            extra={
              <Button
                className="btn-info address-add-btn"
                type="primary"
                size="small"
                onClick={handleShowModal}
              >
                新增收货地址
              </Button>
            }
          >
            <div className="order-selection-container">
              <Row className="settle-row">
                <Col span={4} className="tag-delivery-img">
                  <div className="img-tag selected-tag selected-tag-text pointer">
                    {value.shrxm}
                  </div>
                </Col>
                <Col className="tag-img-bro">
                  <span className="margin-right margin-left">{value.sj}</span>
                  <span className="margin-right margin-left">
                    {value.areaCn && value.xxdz ? `${value.areaCn}${value.xxdz}` : value.xxdz}
                  </span>
                  {list.length > 0 && (
                    <div className="more-address tag-img-bro pointer" onClick={handleShowOption}>
                      <span>更多地址</span>
                      <img src={showOption ? up : down} style={{ width: 10, height: 10 }} alt="" />
                    </div>
                  )}
                </Col>
              </Row>
              <div style={{ display: showOption ? 'block' : 'none' }} className="address-option">
                {options.map((item, index) => (
                  <Row
                    // className={
                    //   `${item.fstatus}` !== '2' ? 'settle-row settle-row-disabled' : 'settle-row'
                    // }
                    className="settle-row"
                    key={index}
                    onClick={() => handleSelectAddress(item)}
                  >
                    <Col span={4} className="tag-delivery-img">
                      <div className="img-tag option-text pointer">{item.shrxm}</div>
                    </Col>
                    <Col className="tag-img-bro">
                      <span className="margin-right margin-left">{item.sj}</span>
                      <span className="margin-right margin-left">
                        {item.areaCn && item.xxdz ? `${item.areaCn}${item.xxdz}` : item.xxdz}
                      </span>
                    </Col>
                  </Row>
                ))}
              </div>
            </div>
          </Card>
        </div>
        <Layout style={{ border: '1px solid #e8e8e8', borderRadius: '2px 2px 0 0' }}>
          <Sider width={200} style={{ background: '#fff' }}>
            <div className="integral-field">
              <p>
                <span>可用积分:</span>
                <span>{changeablePoints}</span>
              </p>
              <p>
                <span>目前消耗积分:</span>
                <span className="text-error">{usedPoints}</span>
              </p>
              <p>
                <span>剩余积分:</span>
                <span className="text-error">{remainPoints}</span>
              </p>
            </div>
            <div className="menu-title">
              <span></span>
              <h3>商品分类</h3>
            </div>
            <Menu defaultSelectedKeys={['ALL']} onClick={(e) => handleSwitchMenu(e)}>
              {menuList.map((item) => {
                return <Menu.Item key={item.code}>{item.name}</Menu.Item>;
              })}
            </Menu>
          </Sider>
          <Content className="exchange-content-wrapper">
            <div className="exchange-content-top-wrapper">
              <div className="exchange-layout-content">
                <div className="exchange-layout-content-left">
                  <div className="exchange-content-item" onClick={() => handleFilter('DEFAULT')}>
                    <span className={sortingType === 'DEFAULT' ? 'exchange-filter-selected' : ''}>
                      默认排序
                    </span>
                  </div>
                  <div className="exchange-content-item" onClick={() => handleFilter('NEW')}>
                    <span
                      className={
                        sortingType === 'NEW_UP' || sortingType === 'NEW_DOWN'
                          ? 'filter-selected'
                          : ''
                      }
                    >
                      新品
                    </span>
                    <div className="exchange-content-item-icon">
                      <img
                        src={
                          sortingType !== 'NEW_UP' && sortingType !== 'NEW_DOWN'
                            ? `${process.env.TARGET}static/imgs/defaultArrow.png`
                            : sortingType === 'NEW_UP'
                            ? `${process.env.TARGET}static/imgs/upDownArrow.png`
                            : sortingType === 'NEW_DOWN'
                            ? `${process.env.TARGET}static/imgs/downUpArrow.png`
                            : null
                        }
                        alt=""
                        height={12}
                        width={14}
                      />
                    </div>
                  </div>
                  <div className="exchange-content-item" onClick={() => handleFilter('POINT')}>
                    <span
                      className={
                        sortingType === 'POINT_UP' || sortingType === 'POINT_DOWN'
                          ? 'filter-selected'
                          : ''
                      }
                    >
                      积分排序
                    </span>
                    <div className="exchange-content-item-icon">
                      <img
                        src={
                          sortingType !== 'POINT_UP' && sortingType !== 'POINT_DOWN'
                            ? `${process.env.TARGET}static/imgs/defaultArrow.png`
                            : sortingType === 'POINT_UP'
                            ? `${process.env.TARGET}static/imgs/upDownArrow.png`
                            : sortingType === 'POINT_DOWN'
                            ? `${process.env.TARGET}static/imgs/downUpArrow.png`
                            : null
                        }
                        alt=""
                        height={12}
                        width={14}
                      />
                      {/* <Icon
                        type="caret-up"
                        className={sortingType === 'POINT_UP' ? 'filter-selected' : ''}
                      /> */}
                    </div>
                  </div>
                  <div className="exchange-content-item">
                    <Form>
                      <Form.Item name="changePointsFrom">
                        {getFieldDecorator('changePointsFrom')(
                          <InputNumber
                            placeholder="最低积分"
                            // style={{ width: '24%' }}
                            onBlur={() => handleFilterPoint()}
                          />,
                        )}
                      </Form.Item>
                      <span style={{ margin: '0 4px' }}>-</span>
                      <Form.Item name="changePointsTo">
                        {getFieldDecorator('changePointsTo')(
                          <InputNumber
                            placeholder="最高积分"
                            // style={{ width: '24%' }}
                            onBlur={() => handleFilterPoint()}
                          />,
                        )}
                      </Form.Item>
                    </Form>
                  </div>
                </div>
                <div className="exchange-layout-content-right">
                  <Input.Search
                    placeholder="请输入商品名称"
                    enterButton={<Icon type="search" />}
                    onSearch={(e) => handleSearch(e)}
                    allowClear
                  />
                </div>
              </div>
            </div>
            <div className="exchange-content-center-wrapper">
              <List
                dataSource={dataSource}
                // pagination={{
                //   ...pagination,
                //   onChange: (page, pageSize) => handleChange(page, pageSize),
                //   showTotal: (total) => `共${total}条`,
                //   showSizeChanger: false,
                // }}
                loading={tbLoading}
                renderItem={(item, index) => (
                  <List.Item
                    key={index}
                    // className={selectedIds.includes(item.id) ? 'list-selected-item' : ''}
                    // onClick={() => handleChooseItem(item)}
                  >
                    <div className="exchange-image-container">
                      <img
                        src={
                          item.itemPicAddr
                            ? `${process.env.ASSETS}/${item.itemPicAddr}`
                            : `${process.env.TARGET}static/imgs/no-drawing.jpg`
                        }
                        alt=""
                        // style={{ width: 160, height: 160 }}
                        onClick={() => handlePreview(item.itemPicAddr)}
                      />
                    </div>
                    <div className="ellipsis exchange-item-line-height" title={item.itemName}>
                      <p style={{ fontSize: 14 }}>{item.itemName}</p>
                    </div>
                    <div className="ellipsis exchange-item-line-height">
                      {(item.itemType === 'A' && item.cpnDesc) ||
                      (item.itemType === 'B' && item.itemDescribe) ? (
                        <Tooltip
                          placement="bottomLeft"
                          title={renderItemTip(item)}
                          // overlayClassName="table-item-tip"
                        >
                          <div className="ellipsis exchange-item-line-height">
                            <p className="ellipsis">
                              {item.itemType === 'A' ? item.cpnDesc : item.itemDescribe}
                            </p>
                            <Icon type="double-right" style={{ transform: 'rotate(90deg)' }} />
                          </div>
                        </Tooltip>
                      ) : null}
                    </div>
                    <div className="exchange-item-line-height">
                      <Statistic
                        value={item.changePoints}
                        valueStyle={{ color: '#0079fe', fontWeight: 'bold', fontSize: '16px' }}
                        suffix={<span style={{ fontSize: '13px' }}>积分</span>}
                      />
                      {item.usingQty === 0 ? (
                        <span className="text-error">已兑完</span>
                      ) : (
                        <span>可兑换数量：{item.usingQty}</span>
                      )}
                    </div>
                    <div className="exchange-item-line-height">
                      {item.usingQty === 0 ? null : (
                        <>
                          <div>
                            <span>兑换数量：</span>
                            <InputNumber
                              // placeholder="0"
                              value={item.qty}
                              style={{ width: 60 }}
                              min={0}
                              maxLength={8}
                              onChange={(val) => handleQtyhange(val, index)}
                              disabled={!item.changeable}
                            />
                          </div>
                          <div>
                            <Button
                              type="primary"
                              size="small"
                              onClick={() => handleExChangeItem(item)}
                              disabled={!item.changeable}
                            >
                              兑换
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  </List.Item>
                )}
              />
              {/* {dataSource.length ? (
                dataSource.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={
                        selectedItem.id === item.id
                          ? 'content-center-item content-center-selected-item'
                          : 'content-center-item'
                      }
                      onClick={() => handleChooseItem(item)}
                    >
                      <div className="image-container">
                        <img
                          src={
                            item.itemPicAddr
                              ? `${process.env.ASSETS}/${item.itemPicAddr}`
                              : `${process.env.TARGET}static/imgs/no-drawing.jpg`
                          }
                          alt=""
                          // style={{ width: 160, height: 160 }}
                          onClick={() => handlePreview(item.itemPicAddr)}
                        />
                      </div>
                      <p className="ellipsis" title={item.itemName}>
                        {item.itemName}
                      </p>
                      <Statistic
                        value={item.changePoints}
                        valueStyle={{ color: '#0079fe', fontWeight: 'bold', fontSize: '16px' }}
                        suffix={<span style={{ fontSize: '13px' }}>积分</span>}
                      />
                    </div>
                  );
                })
              ) : (
                <Empty style={{ width: '100%', textAlign: 'center' }} />
              )} */}
            </div>
            {dataSource.length ? (
              <div className="exchange-content-bottom-wrapper">
                <Pagination
                  total={pagination.total}
                  showTotal={(total) => `共${total}条`}
                  pageSize={pagination.pageSize}
                  current={pagination.current}
                  onChange={(page, pageSize) => handleChange(page, pageSize)}
                />
              </div>
            ) : null}
          </Content>
        </Layout>
        {/* <Tabs
          activeKey={activeKey}
          type="card"
          className="basic-card-tab"
          onChange={handleChangeActive}
        >
          {tabList.map((item) => {
            return (
              <TabPane tab={item.name} key={item.key}>
                <div className="integral-field">
                  <p>
                    <span>可用积分:</span>
                    <span>{changeablePoints}</span>
                  </p>
                  <p>
                    <span>目前消耗积分:</span>
                    <span className="text-error">{usedPoints}</span>
                  </p>
                  <p>
                    <span>剩余积分:</span>
                    <span className="text-error">{remainPoints}</span>
                  </p>
                </div>

                <Table
                  className="tm-table"
                  rowKey={(record, index) => index}
                  dataSource={dataSource}
                  pagination={pagination}
                  locale={locale}
                  onChange={(pagination, filters, sorter) =>
                    handleChange(pagination, filters, sorter)
                  }
                  loading={tbLoading}
                  columns={renderTableColumns(item.key)}
                />
              </TabPane>
            );
          })}
        </Tabs> */}
      </Modal>
      {previewVisible ? (
        <PreviewImgModal
          visible={previewVisible}
          imgValue={currentImg}
          handleCancel={handleChangePreview}
        />
      ) : null}
      {addrVisible ? (
        <Modal
          visible={addrVisible}
          title={
            <>
              <span>新增收货地址</span>
              <Divider type="vertical" />
              <Text type="warning">
                <small>温馨提示：新增地址不会作为正常货物收货地址</small>
              </Text>
            </>
          }
          destroyOnClose={true}
          width={810}
          okType="btn-info"
          bodyStyle={{ padding: 0 }}
          onCancel={handleCancel}
          onOk={handleOk}
        >
          <AddressAdd
            wrappedComponentRef={(form) => (formRef.current = form)}
            formData={formData}
          />
        </Modal>
      ) : null}
    </>
  );
});
